import JoinPage from './JoinPage';
import JoinPageContainer from './JoinPage.container';

export default JoinPageContainer(JoinPage);
